var map = {
	"./ATI.png": 890,
	"./Adapt Ideations.jpg": 5816,
	"./Berlinger.png": 196,
	"./Controlant.png": 2422,
	"./Cryopak.png": 4367,
	"./Cryoport.png": 5542,
	"./DeltaTrak.png": 1586,
	"./ElPro.png": 3302,
	"./Elitechlog.png": 7094,
	"./Ellab.png": 6770,
	"./Fresh liance.png": 4056,
	"./Frigga.jpg": 6752,
	"./OnAsset.png": 9003,
	"./Quake Global.png": 1796,
	"./Roambee.png": 9727,
	"./SenseAware (FedEx).png": 7951,
	"./Sensitech.png": 7696,
	"./Spot see.png": 1509,
	"./Tempmate.png": 9125,
	"./Tive.png": 5718,
	"./Trackonomy.png": 8555
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5374;